<template>
  <div>
    <div class="row" v-if="personality.psiccCode">
      <div class="col-md-12 py-3 mb-4">
        <h2>
          <span class="bubble"
            ><font-awesome-icon class="color-green" icon="arrow-up"
          /></span>
          Personality based job matches
        </h2>
        <p>
          The following jobs have a good match with your personality profile
        </p>
      </div>
      <div
        class="col-lg-4 col-md-6 col-sm-6"
        v-for="item in limitedCareerMatches"
        v-bind:key="item.job"
      >
        <a
          class="panel-job panel-content panel-link"
          target="_blank"
          :href="'https://traitstack.com/jobs/' + item.code + '?ref=plus'"
        >
          <div class="icon-holder">
            <img
              :src="'https://cdn.traitstack.com/static/' + item.topcat + '.svg'"
              class="svg-image"
              alt
            />
          </div>
          <div class="title-holder">
            <h3>{{ item.job }}</h3>
            <p class="subtitle">{{ item.title }}</p>
            <button
              class="fit"
              v-tippy="{ theme: 'navy' }"
              title="Great match with personality"
            >
              <font-awesome-icon icon="circle" />
              <font-awesome-icon icon="circle" />
              <font-awesome-icon icon="circle" />
            </button>
          </div>
        </a>
      </div>
      <div v-if="limitMatches" class="col-12 py-3 text-center">
        <button class="btn btn-primary" @click="limitMatches = false">
          Show all matches ({{ this.transformedCareerMatches.length }})
        </button>
      </div>
      <div class="col-md-12 py-3 mb-4">
        <h2>
          <span class="bubble"
            ><font-awesome-icon class="color-red" icon="arrow-down"
          /></span>
          Personality based job mismatches
        </h2>
        <p>
          The following jobs do not have a good match with your personality
          profile
        </p>
      </div>
      <div
        class="col-lg-4 col-md-6 col-sm-6"
        v-for="item in limitedCareerMismatches"
        v-bind:key="item.job"
      >
        <a
          class="panel-job panel-content panel-link"
          target="_blank"
          :href="'https://traitstack.com/jobs/' + item.code + '?ref=plus'"
        >
          <div class="icon-holder">
            <img
              :src="'https://cdn.traitstack.com/static/' + item.topcat + '.svg'"
              class="svg-image"
              alt
            />
          </div>
          <div class="title-holder">
            <h3>{{ item.job }}</h3>
            <p class="subtitle">{{ item.title }}</p>
            <button
              class="fit red"
              v-tippy="{ theme: 'navy' }"
              title="Poor match with personality"
            >
              <font-awesome-icon icon="circle" />
              <font-awesome-icon class="var" icon="circle" />
              <font-awesome-icon class="var" icon="circle" />
            </button>
          </div>
        </a>
      </div>
      <div v-if="limitMismatches" class="col-12 py-3 text-center">
        <button class="btn btn-primary" @click="limitMismatches = false">
          Show all mismatches ({{ this.transformedCareerMismatches.length }})
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { psiccCode } from "@/assets/psicc.js";
import { transformations } from "@/assets/jobTransformation.js";
export default {
  computed: {
    limitedCareerMatches() {
      if (this.limitMatches) {
        return this.transformedCareerMatches.slice(0, 18);
      } else {
        return this.transformedCareerMatches;
      }
    },
    limitedCareerMismatches() {
      if (this.limitMismatches) {
        return this.transformedCareerMismatches.slice(0, 18);
      } else {
        return this.transformedCareerMismatches;
      }
    },
  },
  props: {
    personality: Object,
  },
  data() {
    return {
      limitMatches: true,
      limitMismatches: true,
      transformations: transformations,
      psiccCode: psiccCode,
      careerMatches: null,
      transformedCareerMatches: [],
      transformedCareerMismatches: [],
    };
  },
  mounted() {
    this.transformedCareerMatches = this.transformCareers(
      this.psiccCode[this.personality.psiccCode].careerMatch
    );
    this.transformedCareerMismatches = this.transformCareers(
      this.psiccCode[this.personality.psiccCode].careerMismatch
    );
  },
  methods: {
    transformCareers(matchedJobs) {
      if (matchedJobs.length) {
        const transformedJobs = [];
        matchedJobs.forEach((career) => {
          let obj = transformations.find((o) => o.job === career);
          if (obj) {
            let cat = obj.code.substring(0, 2);
            obj.topcat = cat + "-0000";
            transformedJobs.push(obj);
          }
        });
        return transformedJobs;
      }
    },
  },
};
</script>
